import { Bid } from '../dtos/bid';
import { BidDetailsTable } from '../views/index';
import { GET_BID_STATUS_CLASS } from '../utils/bid-status-class';
import { GET_BID_STATUS_FROM_STRING } from '../utils/bid-status-text';
import {
	BID_DISPLAY_STATUS_CONSTANTS,
	BID_SOURCE_TYPE,
	BID_STATUS_STRING,
} from '../constants/bidStatus';
import { DATE_MDY } from '../../utils/date/date-parser';
import { FORMAT_SCORE_PERCENTAGE } from 'cargo-chief-commons';

export const BID_DETAILS_TABLE = (
	bidList: Array<Bid> = [],
	SEND_RATE_CON: boolean
): Array<BidDetailsTable> => {
	let results: Array<BidDetailsTable> = [];
	try {
		if (bidList.length > 0) {
			bidList.map((bid: Bid) => {
				let row = {} as BidDetailsTable;
				row.allInPrice = bid.allInPrice;
				row.bidStatus = bid.status;
				row.bidId = bid.id;
				row.businessName = bid.carrierBusinessName;
				row.customerCarrier = bid.customerCarrier;
				row.oldCarrierId = bid.oldCarrierId || null;
				row.carrierId = bid.carrierId;
				row.pickupDate = new Date(DATE_MDY(bid.pickupDate));
				row.transitDays = bid.estimatedDays;
				row.truckLocation =
					bid.truckOriginCity != undefined && bid.truckOriginState != undefined
						? bid.truckOriginCity + ', ' + bid.truckOriginState
						: '';
				row.carrierHQ =
					(bid.carrierCity != undefined && bid.carrierCity != null ? bid.carrierCity + ', ' : '') +
					(bid.carrierState != undefined && bid.carrierState != null ? bid.carrierState : '');
				if (bid.bidHistories.length > 0) {
					// get latest bid history to find who countered bid last
					const bidHistories = bid.bidHistories.sort((a, b) => (b.created > a.created ? 1 : -1));
					row.sourceType = bidHistories[0].sourceType;
				} else {
					row.sourceType = BID_SOURCE_TYPE.CUSTOMER;
				}
				row.statusDisplay = GET_BID_STATUS_FROM_STRING(row.bidStatus, row.sourceType, bid);
				row.statusClass = GET_BID_STATUS_CLASS(row.bidStatus);
				row.lastModified = bid.lastModified;
				row.deliveryDate = new Date(DATE_MDY(bid.deliveryDate));
				row.carrierLastFmcsaUpdate = bid.carrierLastFmcsaUpdate || null;
				row.drivers = bid.drivers;
				row.powerUnits = bid.powerUnits;
				row.carrierContactPhone = bid.carrierContactPhone;
				row.mc = bid.mc;
				row.dot = bid.dot;
				row.porusTruckId = bid.porusTruckId || null;
				row.truckLaneId = bid.truckLaneId || null;
				row.declineReason = bid.declineReason;
				row.isEligibleForBookNow = bid.isEligibleForBookNow;
				row.lastView = bid.lastView;
				row.lastReply = bid.lastReply;
				row.outOfNetwork = bid.outOfNetwork;
				row.vettingSource = bid.vettingSource;
				row.vettingSourceId = bid.vettingSourceId;
				row.carrierOnboardedOn = bid.carrierOnboardedOn;

				row.ccBookingRate = bid.ccBookingRate;
				row.ccEngagementRate = bid.ccEngagementRate;
				row.ccFalloffRate = bid.ccFalloffRate;
				row.ccTotalBookedLoads = bid.ccTotalBookedLoads;
				row.ccScore = bid.ccScore;
				row.vettingAuthorityDisplay = bid.vettingAuthorityDisplay;
				row.vettingInsuranceDisplay = bid.vettingInsuranceDisplay;
				row.vettingOperationsDisplay = bid.vettingOperationsDisplay;
				row.vettingSafetyDisplay = bid.vettingSafetyDisplay;
				row.vettingOtherDisplay = bid.vettingOtherDisplay;
				row.vettingOverallDisplay = bid.vettingOverallDisplay;
				row.infractionDetails = bid.infractionDetails;

				row.ccBookingRateDisplay = FORMAT_SCORE_PERCENTAGE(bid.ccBookingRate);
				row.ccEngagementRateDisplay = FORMAT_SCORE_PERCENTAGE(bid.ccEngagementRate);
				row.ccFalloffRateDisplay = FORMAT_SCORE_PERCENTAGE(bid.ccFalloffRate);

				results.push(row);
			});
		}
	} catch (error) {
		console.log('BID_DETAILS_TABLE error: ', error);
	}
	return results;
};

export { Bid };
